import { CaretLeft, CaretRight } from "@phosphor-icons/react";

// Client-side pager over an already-filtered list. Renders nothing when a single page.
export const PAGE_SIZE = 25;

export const Pagination = ({ page, pageSize = PAGE_SIZE, total, onPage, testId = "pagination" }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const btn =
    "flex h-8 items-center gap-1 rounded-md border border-zinc-800 px-2.5 font-semibold text-zinc-300 transition-colors duration-150 hover:border-indigo-400/40 hover:text-indigo-300 disabled:pointer-events-none disabled:opacity-40";
  return (
    <div
      data-testid={testId}
      className="mt-3 flex flex-wrap items-center justify-between gap-3 border-t border-zinc-800 px-2 py-3 text-xs text-zinc-400"
    >
      <span data-testid={`${testId}-summary`} className="font-mono-data tabular-nums">
        {from}–{to} of {total}
      </span>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          data-testid={`${testId}-prev`}
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          className={btn}
        >
          <CaretLeft size={13} weight="bold" /> Prev
        </button>
        <span data-testid={`${testId}-page`} className="px-1 tabular-nums">
          Page {page} of {totalPages}
        </span>
        <button
          type="button"
          data-testid={`${testId}-next`}
          disabled={page >= totalPages}
          onClick={() => onPage(page + 1)}
          className={btn}
        >
          Next <CaretRight size={13} weight="bold" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
